module.exports = __webpack_public_path__ + "img/sv388.ce6f41e8.png";